import { LOCALES, type Locale } from "@dteba/shared";

import { cn } from "@/lib/utils";
import { useLocale } from "./locale-provider";

const labels: Record<Locale, string> = { en: "EN", id: "ID" };

export function LanguageSwitcher({ className, tone = "light" }: { className?: string; tone?: "light" | "dark" }) {
  const { locale, setLocale, t } = useLocale();

  return (
    <div
      role="group"
      aria-label={t("lang.label")}
      className={cn(
        "inline-flex gap-0.5 rounded-[var(--radius-control)] p-0.5",
        tone === "light" ? "bg-ink/6" : "bg-on-dark/12",
        className,
      )}
    >
      {LOCALES.map((value) => {
        const active = value === locale;
        return (
          <button
            key={value}
            type="button"
            onClick={() => setLocale(value)}
            aria-pressed={active}
            className={cn(
              "min-h-8 rounded-[var(--radius-image)] px-2.5 font-sans text-xs font-semibold transition-colors",
              active
                ? tone === "light"
                  ? "bg-bg text-ink"
                  : "bg-on-dark text-ink"
                : tone === "light"
                  ? "text-ink-soft hover:text-ink"
                  : "text-on-dark/65 hover:text-on-dark",
            )}
          >
            {labels[value]}
          </button>
        );
      })}
    </div>
  );
}
